query contextualizador(
  $scenarioFilter: ScenariosInput
  $scenarioId: ID!
  $originFilter: OriginInput
) {
  base {
    workspaces {
      id
      name
    }
    scenarios(filter: $scenarioFilter) {
      id
      name
      description
      status {
        id
        value
      }
      workspace {
        id
        code
        name
      }
    }
  }
  data(scenarioId: $scenarioId) {
    origins(filter: $originFilter) {
      id
      label
      isProductive
      isReal
      isVisible
      isProtected
    }
  }
}
